import { useSelector } from 'react-redux'

import { DriftUser } from '@driftt/dds.analytics/dist/packages/analytics/lib/types/user'

interface User extends DriftUser {
  status: string
  profile?: Profile
}

interface Profile {
  globalHandle: string
}

export default function useCurrentUser(): User {
  return useSelector((state: any) => state.user)
}
